// type-coverage:ignore-next-line
export const safeObjectKeys = <T extends object>(obj: T) => Object.keys(obj) as (keyof T)[] // the type annotation usage here is safe due to the generics usage

/* Please note that the above is still not 100% type safe but that will fit for our code base... We should never run in the below code.
   How could it be unsafe? Because Typescript exists only at compile time, while Object.keys operates at runtime.

   Example:
   const a = { x: 1, y: 2};
   const b: { x: number } = a;
   const keys = safeObjectKeys(b); // now keys will contains both x and y
*/
